import script from "./SeachArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./SeachArea.vue?vue&type=script&lang=ts&setup=true"

import "./SeachArea.vue?vue&type=style&index=0&id=6f1015ee&lang=less&scoped=true"

import exportComponent from "D:\\myWork\\番顺茶叶官网\\panshunwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f1015ee"]])

export default __exports__